import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentsIcon from "@mui/icons-material/Payments";

// constant
const icons = {
  DisplaySettingsIcon,
  ViewCarouselIcon,
  AutorenewIcon,
  AccountBalanceIcon,
  PaymentsIcon,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const setting = {
  id: "all-setting",
  title: "ตั้งค่า",
  type: "group",
  children: [
    {
      id: "book-bank",
      title: "บัญชีธนาคาร",
      type: "item",
      icon: icons.AccountBalanceIcon,
      url: "/banksetting",
    },
    {
      id: "payment-setting",
      title: "บัญชีเพย์เม้นท์",
      type: "item",
      icon: icons.PaymentsIcon,
      url: "/paymentsetting",
    },

    {
      id: "web-setting",
      title: "ตั้งค่าเว็บไซต์",
      type: "item",
      url: "/web-setting",
      icon: icons.DisplaySettingsIcon,
      breadcrumbs: false,
    },
    {
      id: "banner-setting",
      title: "ตั้งค่าแบนเนอร์",
      type: "item",
      url: "/banner",
      icon: icons.ViewCarouselIcon,
      breadcrumbs: false,
    },
    {
      id: "popup-setting",
      title: "ตั้งค่าป๊อปอัพ",
      type: "item",
      url: "/popup",
      icon: icons.ViewCarouselIcon,
      breadcrumbs: false,
    },
    {
      id: "wordpress-plugin",
      title: "จัดการปลั๊กอินเวิร์ดเพรส",
      type: "item",
      url: "/wordpress-plugin",
      icon: icons.AutorenewIcon,
      breadcrumbs: false,
    },
  ],
};

export default setting;
